@if (store.fiscalYearsScroll().items()?.length) {
    <app-select-input
        [form]="form"
        id="fiscalYear"
        [showLabel]="false"
        [infiniteScroll]="store.fiscalYearsScroll()"
        valueKey="id"
        [appendTo]="null"
    >
        <ng-template #item let-item>
            <span>{{ item.dateFrom | shortDate: 'yyyy' }}</span>
        </ng-template>
        <ng-template #selectedItem let-item>
            <span>{{ item.dateFrom | shortDate: 'yyyy' }}</span>
        </ng-template>
    </app-select-input>
}
